// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"previous"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M11 12L16.25 17.25V6.75L11 12Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M7.5 18V6M16.25 17.25L11 12L16.25 6.75V17.25Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const PreviousIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'previous',
    ref,
    icon: element,
  },
));

PreviousIcon.displayName = 'PreviousIcon';

export default PreviousIcon;
